import { getSeverities } from '../../services/journal/severities.service'

// MF-67 — Journal severities list slice.
export const UPDATE_JOURNAL_SEVERITIES_LIST = 'UPDATE_JOURNAL_SEVERITIES_LIST'
export const TOGGLE_JOURNAL_SEVERITIES_LOADING = 'TOGGLE_JOURNAL_SEVERITIES_LOADING'
export const JOURNAL_SEVERITIES_ERROR = 'JOURNAL_SEVERITIES_ERROR'
export const JOURNAL_SEVERITIES_UPDATE_TOTAL = 'JOURNAL_SEVERITIES_UPDATE_TOTAL'

export const updateSeveritiesList = (value = []) => ({
  type: UPDATE_JOURNAL_SEVERITIES_LIST,
  payload: { value }
})

export const severitiesError = (value = null) => ({
  type: JOURNAL_SEVERITIES_ERROR,
  payload: { value }
})

export const toggleLoadingSeverities = (value = false) => ({
  type: TOGGLE_JOURNAL_SEVERITIES_LOADING,
  payload: { value }
})

export const updateTotalSeverities = (value = 0) => ({
  type: JOURNAL_SEVERITIES_UPDATE_TOTAL,
  payload: { value }
})

export const loadSeverities = (params = {}) => {
  return async (dispatch) => {
    try {
      dispatch(toggleLoadingSeverities(true))
      dispatch(severitiesError())

      const { data } = await getSeverities(params)

      dispatch(updateSeveritiesList(data?.paginatedResults ?? []))
      dispatch(updateTotalSeverities(data?.totalRecords ?? 0))
    } catch (error) {
      dispatch(updateSeveritiesList([]))
      dispatch(updateTotalSeverities(0))
      dispatch(severitiesError(error?.message ?? 'error'))
    } finally {
      dispatch(toggleLoadingSeverities(false))
    }
  }
}
